// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9658df1d","455":"76e5a4a2","977":"b9eeb791"}[chunkId] + ".chunk.js";
};